import type {CheckoutResponse, QuoteSuccessResponse} from "@/entities/booking/api/types";

import {CanonicalAnalyticsEventName, mapCanonicalEventToGtmPayloads} from "./analytics.events";
import {AnalyticsServiceClass} from "./analytics.service";
import type {QuoteRequestedPayload} from "./analytics.types";

export class CheckAvailabilityAnalyticsClass extends AnalyticsServiceClass {
    trackQuote(result: QuoteSuccessResponse): void {
        try {
            const payload: QuoteRequestedPayload = {
                unit_id: result.booking.unitId,
                check_in: result.booking.checkIn,
                check_out: result.booking.checkOut,
                adults: result.booking.adults,
                children: result.booking.children,
                pets: result.booking.pets,
                total_price: result.quote.total,
                currency: result.quote.currency,
                has_error: false,
            };
            for (const gtmPayload of mapCanonicalEventToGtmPayloads({
                name: CanonicalAnalyticsEventName.QuoteRequested,
                properties: {
                    unit_id: payload.unit_id,
                    check_in: payload.check_in,
                    check_out: payload.check_out,
                    adults: payload.adults,
                    children: payload.children,
                    pets: payload.pets,
                    total_price: payload.total_price,
                    currency: payload.currency,
                    success: true,
                },
            })) {
                this.push(gtmPayload);
            }
        } catch (err) {
            console.warn("[CheckAvailabilityAnalytics] trackQuote failed:", err);
        }
    }

    trackQuoteError(unitId: string, checkIn: string, checkOut: string, adults: number, children: number, pets: number): void {
        try {
            const payload: QuoteRequestedPayload = {
                unit_id: unitId,
                check_in: checkIn,
                check_out: checkOut,
                adults,
                children,
                pets,
                total_price: 0,
                currency: "",
                has_error: true,
            };
            for (const gtmPayload of mapCanonicalEventToGtmPayloads({
                name: CanonicalAnalyticsEventName.QuoteRequested,
                properties: {
                    unit_id: payload.unit_id,
                    check_in: payload.check_in,
                    check_out: payload.check_out,
                    adults: payload.adults,
                    children: payload.children,
                    pets: payload.pets,
                    total_price: payload.total_price,
                    currency: payload.currency,
                    success: false,
                },
            })) {
                this.push(gtmPayload);
            }
        } catch (err) {
            console.warn("[CheckAvailabilityAnalytics] trackQuoteError failed:", err);
        }
    }

    trackBeginCheckout(checkout: CheckoutResponse): void {
        try {
            this.trackCanonicalEvent({
                name: CanonicalAnalyticsEventName.CheckoutStarted,
                properties: {
                    checkout_id: checkout.id,
                    unit_id: checkout.booking.unitId,
                    currency: checkout.quote.currency,
                    value: checkout.quote.total,
                },
            });
        } catch (err) {
            console.warn("[CheckAvailabilityAnalytics] trackBeginCheckout failed:", err);
        }
    }
}

export type CheckAvailabilityAnalyticsInstance = CheckAvailabilityAnalyticsClass;

export function CheckAvailabilityAnalytics(): CheckAvailabilityAnalyticsInstance {
    return new CheckAvailabilityAnalyticsClass();
}
